import { Component, OnInit } from '@angular/core';
import { Job } from 'src/@core/interfaces/job/job.model';
import { JobService } from 'src/@core/services/job/job.service';
import { ActivatedRoute } from '@angular/router';
import { Employer } from 'src/@core/interfaces/employer/employer.model';
import { JobType } from 'src/@core/interfaces/job/job-type.model';
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';
import { AppService } from 'src/@core/services/app.service';

@Component({
  selector: 'hour4u-admin-view-purchase-order',
  templateUrl: './view-purchase-order.component.html',
  styleUrls: ['./view-purchase-order.component.scss']
})
export class ViewPurchaseOrderComponent implements OnInit {

  data: Job = new Job();
  employer: Employer;
  jobType: JobType;
  roles = roles;
  entityTypes = entityTypes;
  imageUrl = environment.image_url;
  profile = this.appService.getCurrentAccount();
  poDetails: any = null;
  poId: any = null;

  constructor(
    private jobService: JobService,
    private jobTypeService: JobTypeService,
    private route: ActivatedRoute,
    private appService: AppService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.poId = data.id;
      this.getPOById();
    });
  }

  // get PO By Id
  getPOById() {
    this.jobService.getPOById(this.poId).subscribe((res: any) => {
      this.poDetails = res;
      this.loadData();
    })
  }

  loadData() {
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      let params = { 'entityId': this.profile.entity.id };
      this.jobService.getJobDetailsById(this.poDetails.jobId, params).subscribe((job: any) => {
        this.data = job;
        this.setAgenciesName();
        this.loadJobType();
      })
    }
  }

  setAgenciesName() {
    if (this.data && this.data.assignedEntities && this.data.assignedEntities.length) {
      this.data.assignedEntitiesName = [];
      this.data.assignedEntities.forEach(element => {
        this.data.assignedEntitiesName.push(element.name);
      })
    }
  }

  loadJobType() {
    this.jobTypeService.getById(this.data.jobTypeId).subscribe(type => {
      this.jobType = type;
    })
  }

  getTotalQuantity() {
    let quantity = 0;
    if (this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.poDetails && this.poDetails.jobRateCards && this.poDetails.jobRateCards.length) {
        this.poDetails.jobRateCards.forEach(element => {
          quantity = quantity + element.quantity;
        });
      }
    }

    if (this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.poDetails && this.poDetails.variableJobRateCards && this.poDetails.variableJobRateCards.length) {
        this.poDetails.variableJobRateCards.forEach(element => {
          quantity = quantity + element.quantity;
        });
      }
    }
    return quantity;
  }

  getFinalTotalAmount() {
    let amount = 0;
    if (this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.poDetails && this.poDetails.jobRateCards && this.poDetails.jobRateCards.length) {
        this.poDetails.jobRateCards.forEach(element => {
          amount = amount + (element.totalAmount);
        });
      }
    }

    if (this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.poDetails && this.poDetails.variableJobRateCards && this.poDetails.variableJobRateCards.length) {
        this.poDetails.variableJobRateCards.forEach(element => {
          amount = amount + (element.totalAmount);
        });
      }
    }
    return amount;
  }

  downloadAttachment(attachmentName: string): void {
    // Create an anchor element and trigger a click to download the file
    const link = document.createElement('a');
    link.href = `${this.imageUrl}${attachmentName}`;
    link.target = '_blank';
    link.download = attachmentName;
    link.click();
  }


  // get Total Billing
  getTotalBilling() {
    let totalBilling = 0;
    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.poDetails && this.poDetails.jobRateCards && this.poDetails.jobRateCards.length) {
        this.poDetails.jobRateCards.forEach(element => {
          totalBilling = totalBilling + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.poDetails.variableJobRateCards && this.poDetails.variableJobRateCards.length) {
        this.poDetails.variableJobRateCards.forEach(element => {
          totalBilling = totalBilling + (element.rate * element.quantity);
        });
      }
    }

    return totalBilling;
  }

  // get Total Billing's GST
  getTotalBillingGST() {
    let totalBillingGST = 0;
    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.poDetails && this.poDetails.jobRateCards && this.poDetails.jobRateCards.length) {
        this.poDetails.jobRateCards.forEach(element => {
          totalBillingGST = totalBillingGST + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.poDetails.variableJobRateCards && this.poDetails.variableJobRateCards.length) {
        this.poDetails.variableJobRateCards.forEach(element => {
          totalBillingGST = totalBillingGST + (element.rate * element.quantity);
        });
      }
    }
    return totalBillingGST * 0.18;
  }

  // get Total Billing With GST
  getTotalBillingWithGST() {
    let totalBillingWithGST = 0;

    if (this.data && this.data.billingType && this.data.billingType.includes('FIXED')) {
      if (this.poDetails && this.poDetails.jobRateCards && this.poDetails.jobRateCards.length) {
        this.poDetails.jobRateCards.forEach(element => {
          totalBillingWithGST = totalBillingWithGST + (element.rate * element.quantity * element.days);
        });
      }
    }

    if (this.data && this.data.billingType && this.data.billingType.includes('VARIABLE')) {
      if (this.data && this.poDetails.variableJobRateCards && this.poDetails.variableJobRateCards.length) {
        this.poDetails.variableJobRateCards.forEach(element => {
          totalBillingWithGST = totalBillingWithGST + (element.rate * element.quantity);
        });
      }
    }
    return totalBillingWithGST * 1.18;
  }

  // review page toggle expand
  toggleExpandValue(index: number, forWhat?: string) {
    if (forWhat == 'FIXED') {
      if (this.data.rateCards && this.data.rateCards.length) {
        this.data.rateCards.forEach((rateCard: any, idx) => {
          if (index == idx) {
            rateCard.expanded = !rateCard.expanded;
          }
        });
      }
    }

    if (forWhat == 'VARIABLE') {
      if (this.data.variableJobRateCards && this.data.variableJobRateCards.length) {
        this.data.variableJobRateCards.forEach((rateCard: any, idx) => {
          if (index == idx) {
            rateCard.expanded = !rateCard.expanded;
          }
        });
      }
    }
  }

  preventToggle(event: Event) {
    event.stopPropagation();
  }
}
